export const socialMediaData = [
    {
        href: '#',
        icon: 'fab fa-facebook',
    },
    {
        href: '#',
        icon: 'fab fa-x-twitter',
    },
];
